var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdddepinfoBanbtnbackicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3183 2.49846C11.4608 2.49846 11.6033 2.55096 11.7158 2.66346C11.9333 2.88096 11.9333 3.24096 11.7158 3.45846L6.82578 8.34846C6.46578 8.70846 6.46578 9.29346 6.82578 9.65346L11.7158 14.5435C11.9333 14.761 11.9333 15.121 11.7158 15.3385C11.4983 15.556 11.1383 15.556 10.9208 15.3385L6.03078 10.4485C5.64828 10.066 5.43078 9.54846 5.43078 9.00096C5.43078 8.45346 5.64078 7.93596 6.03078 7.55346L10.9208 2.66346C11.0333 2.55846 11.1758 2.49846 11.3183 2.49846Z",
    fill: "#05A5AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdddepinfoBanbtnbackicon);
export default __webpack_public_path__ + "static/media/adddepinfo-banbtnbackicon.6b8adf2b693473f4472c8768a3bc99e3.svg";
export { ForwardRef as ReactComponent };